import React from 'react';
import Table from './Table';
import Search from './Search';
import FilterTypeEvent from './FilterTypeEvent';
import FilterTime from './FilterTime';
import { connect } from 'react-redux';
import { REDUCER_NAME, fetchListDataTable } from './../reducer';
import Const from './Const';
import './CorporateStyle.scss';
import { I18n } from 'react-redux-i18n';

class Corporate extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchListDataTable());
  }

  getTitleTableDiv = type => {
    return type === Const.listTypeDivEventByKey.cash.key
      ? I18n.t(
          `marketCalendarCorporate.tableTitle.${Const.listTitleTableDiv.cash}`,
        )
      : I18n.t(
          `marketCalendarCorporate.tableTitle.${Const.listTitleTableDiv.stock}`,
        );
  };

  renderTableCorporate = () => {
    const { currentFilterEvents } = this.props;
    if (currentFilterEvents === Const.listFilterEventByKey.ipo.key) {
      return (
        <div className="table-corporate d-flex flex-column flex-fill">
          {Const.listTypeListEvent.map(type => (
            <div key={type} className="d-flex flex-column flex-fill">
              <div className="text-div">
                {I18n.t(`marketCalendarCorporate.tableTitle.${type}`)}
              </div>
              <Table
                key={type}
                isParentFullHeight={false}
                typeDiv={type}
                countTable={2}
                offsetTable={35}
              />
            </div>
          ))}
        </div>
      );
    }

    return currentFilterEvents === Const.listFilterEventByKey.div.key ? (
      <div className="table-corporate d-flex flex-column flex-fill">
        {Const.listTypeDivEvent.map(type => (
          <div key={type} className="d-flex flex-column flex-fill">
            <div className="text-div">
              <a>{this.getTitleTableDiv(type)}</a>
            </div>
            <Table
              key={type}
              isParentFullHeight={false}
              typeDiv={type}
              countTable={2}
              offsetTable={35}
            />
          </div>
        ))}
      </div>
    ) : (
      <div className="table-corporate d-flex flex-column flex-fill pt-10">
        <Table />
      </div>
    );
  };

  render() {
    return (
      <div className="corporate d-flex flex-column flex-fill">
        <div className="row w-100">
          <div className="col-12 list-filter">
            <Search
              disabled={false}
              typeSearch={'Search'}
              dateRangeOption={null}
            />
            <FilterTypeEvent />
          </div>
        </div>
        <div>
          <FilterTime />
        </div>
        <div className="d-flex flex-fill flex-column mb-10">
          {this.renderTableCorporate()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentFilterEvents: state[REDUCER_NAME].currentFilterEvents,
    listCashDividend: state[REDUCER_NAME].listCashDividend,
    listStockDividend: state[REDUCER_NAME].listStockDividend,
  };
};

export default connect(mapStateToProps)(Corporate);
